module.exports = __webpack_public_path__ + "static/media/card.b938d47d.svg";